import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    const checkedRadio = document.querySelector('input[name="about-tab"]:checked')
    if (checkedRadio) {
      this.showImage(checkedRadio.id)
    }
  }

  toggle(event) {
    this.showImage(event.currentTarget.id)
  }

  showImage(id) {
    this.imageTargets.forEach(image => {
      const imageId = image.dataset.idValue

      if (imageId === id) {
        image.classList.remove("hidden")
      } else {
        image.classList.add("hidden")
      }
    })
  }
}
